import { render } from "./Kefu.vue?vue&type=template&id=f6fdbdbc"
import script from "./Kefu.vue?vue&type=script&lang=js"
export * from "./Kefu.vue?vue&type=script&lang=js"

import "./Kefu.vue?vue&type=style&index=0&id=f6fdbdbc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__